import { render, staticRenderFns } from "./ErrorInfoFooter.form.vue?vue&type=template&id=18c1f3ba&scoped=true&"
import script from "./ErrorInfoFooter.form.vue?vue&type=script&lang=js&"
export * from "./ErrorInfoFooter.form.vue?vue&type=script&lang=js&"
import style0 from "./ErrorInfoFooter.form.vue?vue&type=style&index=0&id=18c1f3ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1f3ba",
  null
  
)

export default component.exports